module.exports = __webpack_public_path__ + "static/media/owners.248b54f1.png";